<template>
  <div class="ba-w-100 ba-grid ba-gp-08">
    <template v-if="!loading" class="ba-grid a-gp-08">

      <div class="ba-flex ba-jc-fe ba-gp-1">
        <a href="https://office.builderall.com/br/office/new-social-proof" target="_blank" class="ba-btn ba-md ba-blue">
          <builderall-icon code='4970'></builderall-icon>
          {{ $t('ct-goto-social-proof') }}
        </a>
        <button type="button" class="ba-btn ba-blue ba-md" @click="addConfigRow">
          <i class="svg-icon svgi-add-circle mr-3"></i>{{ $t('ct-add-proof-config') }}
        </button>
      </div>
      
      <template v-if="campaigns.length > 0">

        <div class="ba-grid ba-w-100 ba-gp-08" v-for="(socialproof_campaign, i) in socialproof_settings" :key="i">
           <div class="ba-flex ba-ai-center ba-gp-04">
            <span class="ba-custom-label" v-text="$t('ct-social-proof-campaign')"></span>
            <builderall-icon 
              style="width: 18px; height: 18px;"
              ba-tooltip-position='left' 
              :ba-tooltip-title="$t('ct-one-proof-by-page-tooltip')"
              class="ba-color-light15"
              code='help'></builderall-icon>
          </div>
          <div class="ba-flex ba-gp-08"> 
            <select v-if="socialproof_campaign && campaigns" :name="`campaing-${i}`" :id="`campaing-${i}`" class="ba-select w-100" v-model="socialproof_campaign.id">
              <option value="0" disabled selected>{{ $t('ct-social-proof-select') }}</option>
              <option 
                v-for="(campaign, index) in campaigns"
                :value="campaign.id"
                :key="index"
                v-show="!campaignIsAlreadySelected(campaign, socialproof_campaign)">
                {{ campaign.name }}
              </option>
            </select>
            <button
              class='ba-btn ba-btn-trash ba-sm ba-rounded'
              ba-tooltip-position='top'
              :ba-tooltip-title="$t('ct-exclude')"
              @click.prevent="removeConfigRow(i)"
              >
                <builderall-icon code='trash' />
            </button>
          </div>
          <div class="ba-grid" v-if="website && website.layouts && website.layouts[0] && socialproof_campaign && socialproof_campaign.id > 0">
            <span class="ba-custom-label">{{ $t('ct-pages') }}</span>
            <div class="ba-w-100 ba-flex ba-gp-08 ba-f-wrap">
              <div v-for="(page, index) in website.layouts[0].pages" :key="index">
                <div class="ba-form-check">
                  <input
                    type="checkbox"
                    :value="page.id"
                    :id="`${i}-page-${page.id}`"
                    v-model="socialproof_campaign.pages"
                    :disabled="pageIsAlreadySelected(page.id, socialproof_campaign)"
                    ba-tooltip-position='top'
                    :ba-tooltip-title="pageIsAlreadySelected(page.id, socialproof_campaign) ? $t('ct-page-cant-selected-proof') : null">
                  <label :for="`${i}-page-${page.id}`">{{ page.name }}</label>
                </div>
              </div>
            </div>
          </div>
          <hr class="ba-hr-row">
        </div>

        <div v-if="!socialproof_settings.length" class="ba-custom-label">
          {{  $t('ct-popup-empty') }}
        </div>

        <div class="ba-w-100 ba-flex ba-ai-center ba-gp-08 ba-jc-fe">
          <button class="ba-btn ba-md ba-blue" @click="save">{{ $t('ct-save') }}</button>
        </div>
      </template>
      <template v-else>
        <div class="ba-grid ba-gp-08">
          <span>{{ $t('ct-social-proof-empty-campaign') }}</span>
          <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fs">
            <a href="https://office.builderall.com/br/office/new-social-proof" target="_blank"
            class="ba-btn ba-md ba-blue"><builderall-icon code='4970'></builderall-icon>{{ $t('ct-goto-social-proof') }}</a>
          </div>
        </div>
      </template>
    </template>
    <div class="text-center" v-else>
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { getAllCampaigns } from '../../../../js/services/integrations-internas/socialProof';
import { getWebsiteConfig, setWebsiteConfig } from '../../../../js/services/editor/configManager';
import { get as getWebsite } from '../../../../js/services/editor/website';

export default {
  name: 'SocialProof',

  props: ['website_id'],

  components: {
    SweetModal
  },

  data() {
    return {
      loading: false,
      website: {
        layouts: [{ pages: [] }]
      },
      website_configs: [],
      campaigns: [],
      socialproof_campaign_base: {
        id: 0,
        pages: [],
        campaign: {}
      },
      socialproof_settings: [],
      officeDomain: ''
    };
  },
  async mounted() {
    await this.getAllCampaigns();
    await this.getWebsite();
    await this.getWebsiteConfigs();

    // If there are campaigns and no settings, add a default config row
    if (this.campaigns.length && !this.socialproof_settings.length) {
      this.addConfigRow();
    }
  },

  created () {
    this.officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';
  },

  methods: {
    addConfigRow() {
      this.socialproof_settings.push(JSON.parse(JSON.stringify(this.socialproof_campaign_base)))
    },

    removeConfigRow(index) {
      this.socialproof_settings.splice(index, 1)
    },

    campaignIsAlreadySelected(campaign, socialproof_campaign) {
      return this.socialproof_settings.filter(c => c.id == campaign.id && c.id != socialproof_campaign.id).length > 0
    },

    pageIsAlreadySelected(page_id, socialproof_campaign) {
      return this.socialproof_settings.filter(c => c.id != socialproof_campaign.id).flatMap(c => c.pages).includes(page_id)
    },

    // async open() {
    //   // this.$refs['social-proof'].open();

    //   this.$loading.show();
    //   this.loading = true;

    //   this.getAllCampaigns();
    //   await this.getWebsite();
    //   await this.getWebsiteConfigs();

    //   this.$loading.hide();
    // },


    async getWebsite() {
      getWebsite(this.$route.params.id || this.$route.params.website_id)
        .then(data => {
          this.website = data.data;
        })
        .catch(error => {
          console.warn(error);
        });
    },

    async getWebsiteConfigs() {
      await getWebsiteConfig(this.$route.params.id || this.$route.params.website_id)
        .then(({ data }) => {
          this.website_configs = data;

          if (Object.keys(data).includes('socialProofSettings')) {
            const config = JSON.parse(this.website_configs['socialProofSettings'].value)
            this.socialproof_settings = Array.isArray(config) ? config : [config];
          }
        })
        .catch(error => {
          console.error('error', error);
        });
    },

    async getAllCampaigns() {
      this.loading = true;
      await getAllCampaigns()
        .then(res => {
          if (!res.data.error) {
            if (res.data.data)
              this.campaigns = res.data.data.data;
            this.loading = false;

          }
        })
        .catch(error => {
          console.error('error', error);
          this.loading = false;

        });

    },

    save() {

      const payload = this.socialproof_settings.map(s => ({
          ...s, 
          campaign: this.campaigns.find(campaign => campaign.id === s.id)
        })
      ).filter(s => 
        !!s.campaign 
        && s.pages.length > 0
      );


      let data = {
        website_id: this.$route.params.id || this.$route.params.website_id,
        key: 'socialProofSettings',
        value: JSON.stringify(payload.length ? payload : [])
      };

      this.$loading.show();

      setWebsiteConfig(data)
        .then(({ data }) => {
          this.$snotify.success(this.$t('ct-saved-successfully'));
        })
        .catch(err => console.warn(err))
        .finally(() => this.$loading.hide());
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SocialProof.vue